import type { AccountKey } from 'owa-client-types';

/**
 * The AccountKey that is used for an account that is being added and not yet in
 * the owa-account-source-list-store
 */
export const accountKeyForAddAccount: AccountKey = 'add-account' as AccountKey;
